var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"globe\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9019 22.5C17.7008 22.5 22.4019 17.799 22.4019 12C22.4019 6.20101 17.7008 1.5 11.9019 1.5C6.10287 1.5 1.40186 6.20101 1.40186 12C1.40186 17.799 6.10287 22.5 11.9019 22.5Z",
    stroke: "#454D66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.40186 12H22.4019",
    stroke: "#454D66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9019 1.5C14.5282 4.37527 16.0208 8.10664 16.1019 12C16.0208 15.8934 14.5282 19.6247 11.9019 22.5C9.27556 19.6247 7.78301 15.8934 7.7019 12C7.78301 8.10664 9.27556 4.37527 11.9019 1.5Z",
    stroke: "#454D66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.899ca9c755efec83ad3a393af3ee7718.svg";
export { ForwardRef as ReactComponent };